<template>
	<div class="container">
		<!--页面开始-->
		<div class="result">
			<!--C清晰T清晰-->
			<div v-if="resultType === 1" class="res_box">
				<div class="top_tip">
					只要 T 线可见，无论它颜色多浅，都应解释为阳性结果。
				</div>
				<div style="padding: 0.6rem;">
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/chinese/img_ct.webp')"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
				</div>
				<!--写文字-->
				<div class="step_box">
					<ul>
						<li>无论您何时获得阳性结果，都无需再进行重复测试。检测结果呈阳性意味着在您的样本中检测到了新型冠状病毒，您可能感染了新冠并且具有传染性。</li>
						<li>请立即联系您的医生/初级保健医生或当地卫生部门，并遵守当地有关自我隔离的指南。</li>
						<li class="mouse_hover" @click="testbook">请参阅 <span class="col_blue">使用说明</span> 以获取更多信息。</li>
					</ul>
				</div>
				<!--写文字-->
			</div>
			<!--C清晰T清晰-->
			<!--C清晰T没有-->
			<div v-if="resultType === 2" class="res_box">
				<div style="padding: 0.6rem;">
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/chinese/img_c_not.webp')"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
				</div>
				<!--写文字-->
				<div class="step_box">
					<ul>
						<li>
							阴性结果应被视为假定结果，应进行相关连续测试以确认结果。
						</li>
						<li style="font-weight: bold;">
							<div>
								为提高检测结果的准确性，您应该：
							</div>
							<div style="text-indent: 0.4rem;">
								如果您在检测的第一天出现症状，请在 48 小时后再次检测。
							</div>
							<div style="text-indent: 0.4rem;">
								如果您在测试的第一天没有症状，请至少 48 小时后再进行两次测试，这两次测试也须间隔至少48小时。
							</div>
						</li>
						<li class="mouse_hover" @click="testbook">请参阅 <span class="col_blue">使用说明</span> 以获取更多信息。</li>
					</ul>
				</div>
				<!--写文字-->
			</div>
			<!--C清晰T没有-->
			<!--C没有T清晰-->
			<div v-if="resultType === 3" class="res_box">
				<div style="padding: 0.6rem;">
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/chinese/img_cno_t.webp')"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
				</div>
				<!--写文字-->
				<div class="step_box">
					<ul>
						<li>用新的拭子和新的检测卡重新测试。</li>
						<li>如果问题仍然存在，请停止使用该产品并联系我们寻求技术支持。</li>
						<li class="mouse_hover" @click="testbook">请参阅 <span class="col_blue">使用说明</span> 以获取更多信息。</li>
					</ul>
				</div>
				<!--写文字-->
			</div>
			<!--C没有T清晰-->
			<!--C没有T没有-->
			<div v-if="resultType === 4" class="res_box">
				<div style="padding: 0.6rem;">
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/chinese/img_cno_tno.webp')"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
				</div>
				<!--写文字-->
				<div class="step_box">
					<ul>
						<li>用新的拭子和新的检测卡重新测试。</li>
						<li>如果问题仍然存在，请停止使用该产品并联系我们寻求技术支持。</li>
						<li class="mouse_hover" @click="testbook">请参阅 <span class="col_blue">使用说明</span> 以获取更多信息。</li>
					</ul>
				</div>
				<!--写文字-->
			</div>
			<!--C没有T没有-->
		</div>
		<!--页面开始-->
		<div class="btn_box">
			<van-button
				type="primary"
				block
				round
				color="linear-gradient(to right, #a74af2, #5949f2)"
				@click="goInfo"
			>
				下一步
			</van-button>
		</div>
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			resultType: null,
			btnName:''
		}
	},
	created(){
		this.$toast.loading({
			duration: 0,
		});
		if(this.$route.query.cline === 'Yes' && this.$route.query.tline === 'Yes'){
			//阳性
			this.resultType = 1;
			this.btnName = 'Finish';
		}else if(this.$route.query.cline === 'Yes' && this.$route.query.tline === 'No'){
			//阴性
			this.resultType = 2;
			this.btnName = 'Next';
		}else if(this.$route.query.cline === 'No' && this.$route.query.tline === 'Yes'){
			//无效
			this.resultType = 3;
			this.btnName = 'Next';
		}else if(this.$route.query.cline === 'No' && this.$route.query.tline === 'No'){
			//无效
			this.resultType = 4;
			this.btnName = 'Next';
		}else{
			this.$router.push({path: '/chinese/notice'});
		}
	},
	mounted() {
		this.$toast.clear();
	},
	watch: {
		//
	},
	methods: {
		//进入检测第一步
		goInfo() {
			sessionStorage.clear();
			if(this.btnName == 'Finish') {
				this.$router.push({path: '/chinese/stepNight'});
			}else if(this.btnName == 'Next') {
				this.$router.push({path: '/chinese/notice'});
			}
		},
		//进入说明书
		testbook() {
			this.$router.push({path: '/chinese/manual'});
		},
		
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
.result{
	padding-top: 1rem;
}
.top_tip{
	margin: 0rem 0.9rem 0 0.9rem;
	padding: 0.25rem 0.45rem;
	background-color: #ffcaca;
	font-size: 0.32rem;
	color: #720000;
	border-radius: 8px;
	border: 1px #720000 solid;
	font-weight: bold;
}
.res_box img{
	width: 100%;
}
.res_box .tit_box{
	padding: 0.2rem 1.2rem 0 0.8rem;
}
.book_box{
	padding: 0.4rem 1.2rem 0 0.8rem;
}
.btn_box{
	position: fixed;
	bottom: 0.667rem;
	width: 100%;
	padding: 0 0.9rem 0 0.9rem;
}
.btn_box img{
	width: 100%;
}
.col_blue{
	color: rgb(0, 120, 255);
}

.step_box{
	padding: 0.1rem 1rem;
}
.step_box ul li{
	padding: 0.18rem 0 0.18rem 0;
	font-size: 0.427rem;
}
.step_box ul li span{
	font-size: 0.427rem;
}
.step_box .mouse_hover{
	cursor: pointer;
}

>>> .van-button{height: 1.2rem;}
>>> .van-button__text{color: #ffffff;font-size: 0.48rem;font-weight: bold;}

@media only screen 
and (device-width : 375px) 
and (device-height : 667px) 
and (-webkit-device-pixel-ratio : 2) {
   .btn_box{
	   position: relative;
	   padding: 1.5rem 0.9rem 0.667rem 0.9rem;
   }
}
@media screen and (min-device-width : 768px){
	.btn_box{
		position: relative;
		width: 100%;
		padding: 3rem 0.9rem 0 0.9rem;
	}
} 
</style>
